import Pagination from 'react-js-pagination'
import styled from "styled-components";

type Props = {
    activePage: number;
    totalItemsCount: number | undefined;
    handlePageChange: (selectedPage: number) => void; 
  }

export default function SPagination(props: Props) {
    return (
        <PaginationBox>
            <Pagination
                activePage={props.activePage}
                itemsCountPerPage={8}
                totalItemsCount={props.totalItemsCount ?? 0}
                pageRangeDisplayed={5}
                onChange={props.handlePageChange}
                hideFirstLastPages={true}
            />
        </PaginationBox>
      );
}

const PaginationBox = styled.div`
.pagination {
    display: flex; 
    justify-content: right; 
    gap:6px; 
    margin-top:8px;
}
ul { 
    list-style: none; 
    padding: 0; 
}
ul.pagination li {
    display: inline-block;
    width: 32px;
    height: 32px; 
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem; 
    cursor: pointer;
}
ul.pagination li:first-child { 
    border: 1px solid #BCBCBC; 
}
ul.pagination li:last-child { 
    border: 1px solid #BCBCBC; 
}
ul.pagination li { 
    border-radius: 4px 
}
ul.pagination li a { 
    text-decoration: none; 
    color: #BCBCBC; 
    font-size: 15px; 
}
ul.pagination li.active a { 
    color: #131C4D; 
} 
`